import { EntityModel } from '@/interfaces'
import {
  ALL_EMPLOYEES_BLOCKS_QUERY,
  CREATE_EMPLOYEES_BLOCK_MUTATION,
  DELETE_EMPLOYEES_BLOCK_MUTATION,
  FORCE_DELETE_EMPLOYEES_BLOCK_MUTATION,
  SINGLE_EMPLOYEES_BLOCK_QUERY,
  UPDATE_EMPLOYEES_BLOCK_MUTATION,
} from './graphql'
import employeeEntity from '@/entities/employee/entity'

const cmsEmployeesBlockModel: EntityModel = {
  name: 'employeesBlock',
  namePlural: 'employeesBlocks',
  uniqueName: 'cmsEmployeesBlock',
  uniqueNamePlural: 'cmsEmployeesBlocks',
  path: 'cms/blocks/employees_block',
  baseUrl: '/cms/blocks/employees_blocks',
  translationPrefix: 'entities:cmsEmployeesBlock.',
  getDisplayName: (values: any) => {
    return ''
  },
  gql: {
    getAll: ALL_EMPLOYEES_BLOCKS_QUERY,
    getSingle: SINGLE_EMPLOYEES_BLOCK_QUERY,
    create: CREATE_EMPLOYEES_BLOCK_MUTATION,
    update: UPDATE_EMPLOYEES_BLOCK_MUTATION,
    delete: DELETE_EMPLOYEES_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_EMPLOYEES_BLOCK_MUTATION,
  },
  attributes: {
    employees: {
      name: 'employees',
      label: 'entities:cmsEmployeesBlock.attributes.employees.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return employeeEntity
      },
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsEmployeesBlockModel
